import * as React from 'react';
import { BodyCell } from '@tableau/widgets-datagrid';
import { IColumnFactoryParameters } from '../ListViewGridColumnGenerator';
import * as Layout from '../../../../common/styles/Layout';
import { LinkCell } from './LinkCell';
import { IconStyle, LabelIconStyle } from '../../../utils/DataCatalogUtils';
import { ContentTypeCell, ContentTypeCellOptions } from './ContentTypeCell';
import { LabelWrapper } from './Labels';
import { IVirtualConnection } from '../../../models/httpClient/MetaDataResults';
import { SessionManagementService } from '../../../services/SessionManagementService';

export function VirtualConnectionNameCell(
  parameters: IColumnFactoryParameters,
  contentTypeCellOptions: ContentTypeCellOptions
): React.Factory<BodyCell.Props> {
  return React.createFactory(function TableNameCell(props: BodyCell.Props) {
    const contentTypeCellFactory = ContentTypeCell(contentTypeCellOptions);
    const linkCellFactory = LinkCell(
      parameters.generateLinkForName,
      true,
      parameters.listViewParams.urls,
      parameters.listViewParams.searchTerm,
      parameters.listViewParams.total
    );

    const dataQualityIndicators = (props.row.data as IVirtualConnection).dataQualityIndicators;

    const hasWarning = dataQualityIndicators ? dataQualityIndicators.some((dqi) => dqi.isActive && dqi.category === 'WARNING') : false;

    const hasSevereWarning = hasWarning
      ? dataQualityIndicators.some((dqi) => dqi.isActive && dqi.category === 'WARNING' && dqi.isSevere)
      : false;

    const isCertified = dataQualityIndicators
      ? dataQualityIndicators.some((dqi) => dqi.isActive && dqi.category === 'CERTIFICATION')
      : false;

    const labels = LabelWrapper(
      {
        catalogEnabled: SessionManagementService.instance.catalogingOnSiteEnabled(),
        content: {
          contentId: props.row.data.id,
          contentLuid: props.row.data.crassData.luid,
          contentType: 'virtualConnection',
          contentName: props.row.data.name,
          subjectArea: 'virtualConnection',
        },
        includeUpstream: false,
        includeParented: false,
        probablyOrEager: {
          certified: isCertified,
          warning: hasWarning ? { count: 1, value: 'Warning', severe: hasSevereWarning } : undefined,
        },
        testId: props.row.data.contentType + '-search-label',
        controls: {
          kind: 'icon',
          siteUrls: parameters.listViewParams.urls,
        },
      },
      parameters.listViewParams.urls,
      props.row.data.crassData.siteLuid
    );

    return (
      <div className={Layout.flexH} style={{ width: '100%' }}>
        <div className={IconStyle}>{contentTypeCellFactory(props)}</div>
        <div className={LabelIconStyle}>{labels}</div>
        <div className={Layout.flexAuto} style={{ overflow: 'hidden' }}>
          {linkCellFactory(props)}
        </div>
      </div>
    );
  });
}
